import { ViewerImage } from 'app/components/Viewer/types';

export const isFullResolutionDicom = (image: ViewerImage) =>
  image?.acquisitionTime && image?.initialDataImage?.data instanceof Uint16Array;
